import { render, staticRenderFns } from "./share-planner-settings.vue?vue&type=template&id=338f4ef8&scoped=true&"
import script from "./share-planner-settings.vue?vue&type=script&lang=ts&"
export * from "./share-planner-settings.vue?vue&type=script&lang=ts&"
import style0 from "./share-planner-settings.vue?vue&type=style&index=0&id=338f4ef8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f4ef8",
  null
  
)

export default component.exports